module.exports = __webpack_public_path__ + "5bb1c5b5fae118666d37c865ac812112.fbx";